/** 商品カード（UI/UX設計書 §7.3：256×320・ホバーで elevation-2） */
import { Link } from "react-router-dom";
import { yen } from "../lib/format";
import type { Product } from "../lib/types";
import { Badge, Rating } from "./ui";

export default function ProductCard({ product }: { product: Product }) {
  const soldOut = product.available_quantity <= 0;
  return (
    <article className="card card--hoverable">
      <Link to={`/products/${product.id}`} style={{ color: "inherit", textDecoration: "none" }}>
        <div style={{ aspectRatio: "1 / 1", background: "var(--surface-app)", borderRadius: "var(--radius-lg) var(--radius-lg) 0 0", overflow: "hidden" }}>
          {product.thumbnail_url ? (
            <img src={product.thumbnail_url} alt={product.name} loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          ) : (
            <div className="skeleton" style={{ width: "100%", height: "100%" }} />
          )}
        </div>
        <div className="card__body stack" style={{ gap: "var(--space-2)" }}>
          <div className="row" style={{ gap: "var(--space-2)", flexWrap: "wrap" }}>
            {product.product_type === "digital" && <Badge tone="primary">デジタル</Badge>}
            {soldOut ? <Badge tone="muted">在庫なし</Badge> : product.available_quantity <= 3 && <Badge tone="warning">残りわずか</Badge>}
          </div>
          <h3 style={{ font: "var(--font-body)", fontWeight: 600, margin: 0 }}>{product.name}</h3>
          <p className="price" style={{ margin: 0, fontSize: "1.25rem" }}>{yen(product.min_price ?? product.base_price)}</p>
          <Rating value={product.reviews.average} count={product.reviews.count} />
        </div>
      </Link>
    </article>
  );
}
